<template>
    <card>
        <card-header>{{ title }}</card-header>
        <card-body class="pt-0" v-if="loading" style="min-height: 200px;">
            <card-spinner/>
        </card-body>
        <card-body class="pt-0" v-if="!loading">
            <nps-response-metrics :data="npsOverview" v-if="npsOverview"/>
        </card-body>
    </card>
</template>

<script>
    import {mapState} from 'vuex';

    export default {
        props: {
            title      : {default: 'Results Overview'},
            npsOverview: {default: ({})},
            loading    : {type: Boolean}
        },
    }
</script>
